import { CommonModule } from "@angular/common";
import { inject, NgModule, provideAppInitializer } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { CmsConfig, ConfigModule, I18nModule } from "@spartacus/core";
import { RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { NeedAssistanceModule } from "../shared/modules/need-assistance/need-assistance.module";
import { RecaptchaService } from "../shared/services/recaptcha.service";
import { ForgotUserPasswordComponent } from "./forgot-user-password/forgot-user-password.component";
import { HelpHintRecoveryQuestionComponent } from "./help-hint-recovery-question/help-hint-recovery-question.component";
import { LoginPageComponent } from "./login-page/login-page.component";
import { SetPasswordComponent } from "./set-password/set-password.component";
import { UserDataRecoveryActionComponent } from "./user-data-recovery-action/user-data-recovery-action.component";

const globalSettings: RecaptchaSettings = { siteKey: '' };
const startIndex = 6;
const totalCharsNeeded = 2;
const language = location.pathname.substr(startIndex, totalCharsNeeded);

function loadRecaptcha(recaptchaService: RecaptchaService) {
  return () => recaptchaService.loadRecaptchaConfig();
}

@NgModule({
  declarations: [
    ForgotUserPasswordComponent,
    SetPasswordComponent,
    HelpHintRecoveryQuestionComponent,
    UserDataRecoveryActionComponent,
    LoginPageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    NeedAssistanceModule,
    NgbModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        LoginHelpComponent: {
          component: ForgotUserPasswordComponent,
        },
        UserNameRecoverySuccessComponent: {
          component: UserDataRecoveryActionComponent,
        },
        HintQuestionAnswerComponent: {
          component: HelpHintRecoveryQuestionComponent,
        },
        ForgotPasswordComponent: {
          component: SetPasswordComponent,
        },
        LoginPageReferenceComponent: {
          component: LoginPageComponent,
        },
      },
    } as CmsConfig),
  ],
  providers: [
    provideAppInitializer(() => {
        const initializerFn = (loadRecaptcha)(inject(RecaptchaService));
        return initializerFn();
      }),
    {
      provide: RECAPTCHA_SETTINGS,
      useFactory: (recaptchaService: RecaptchaService) => {
        const key = recaptchaService.getSiteKey();
        return key ? { siteKey: key } : {};
      },
      deps: [RecaptchaService],
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: (recaptchaService: RecaptchaService) =>
        recaptchaService.isEnabled() ? language : '',
      deps: [RecaptchaService],
    },
  ],
})
export class ForgotUserPasswordModule { }
